import { render, staticRenderFns } from "./getCodeResetPhone.vue?vue&type=template&id=6b2aa15d&scoped=true&"
import script from "./getCodeResetPhone.vue?vue&type=script&lang=js&"
export * from "./getCodeResetPhone.vue?vue&type=script&lang=js&"
import style0 from "./getCodeResetPhone.vue?vue&type=style&index=0&id=6b2aa15d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2aa15d",
  null
  
)

export default component.exports